// extracted by mini-css-extract-plugin
export default {"main":"JoiningOptions_main__ASqao","heading":"JoiningOptions_heading__2yc3X","options_container":"JoiningOptions_options_container__Dp-6X","option":"JoiningOptions_option__Yl6z-"};